<template>
	<b-container class="overlay" :class="containerclass">
		<b-row align-v="center" class="vh-100">
			<b-col>
				<b-card style="width:26rem" class="mx-auto bg-none border-none my-auto">
					<b-form @submit.prevent="submit">
						<p>
							{{ invite ? $t("2fa.info-text-email") : $t("2fa.info-text") }}
						</p>
						<p class="text-danger">
							{{ errortext }}
						</p>
						<b-form-group :label="$t('2fa.label-text')" label-for="login">
							<b-form-input
								ref="input"
								v-model="displyCode"
								style="text-align: center;"
								size="lg"
								type="text"
								autocomplete="off"
								required
								:placeholder="$t('2fa.field-placeholder')"
							/>
						</b-form-group>
						<b-form-group>
							<b-button
								ref="submit"
								type="submit"
								variant="primary"
								block
							>
								{{ $t("2fa.button-text") }}
							</b-button>
						</b-form-group>
						<b-form-group>
							<div class="text-center">
								<span :class="{link: resendLockoutTimer == 0}" @click="resend">
									{{ resendLockoutTimer == 0 ? $t("2fa.resend-link") : $t('2fa.please-wait', {seconds: resendLockoutTimer}) }}
								</span>
							</div>
						</b-form-group>
						<b-form-group v-if="isSetup">
							<div class="text-center">
								<span class="link" @click="setup">
									{{ $t("2fa.code-not-received-link") }}
								</span>
							</div>
						</b-form-group>
					</b-form>
				</b-card>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
export default {
	name: 'Enter2FA',
	props: {
		invite: {
			type: Boolean,
			default: false,
		},
		isSetup: {
			type: Boolean,
			default: false,
		},
		callback: {
			type: Function,
			required: true,
		},
	},
	data: () => ({
		form: {
			code: '',
		},
		containerclass: 'hidden',
		errortext: '',
		resendLockoutTimer: 0,
		resendLockoutInterval: null,
	}),
	computed: {
		displyCode: {
			get() {
				return this.form.code.split('').join('  ·  ');
			},
			set(v) {
				v = v.replace(/[^0-9]/g, '');
				if (v.length === 6) {
					this.$refs.input.readOnly = true;
					this.$refs.submit.focus();
				}
				if (v.length > 6) {
					return;
				}
				this.form.code = v;
			},
		},
	},
	methods: {
		submit() {
			this.errortext = '';
			if (this.form.code.length !== 6) {
				this.errortext = this.$t('2fa.code-length-error');
				return;
			}
			this.callback(this.form.code);
			this.form.code = '';
			this.hide();
		},
		show() {
			this.containerclass = `${this.$store.state.bg_class}`;
		},
		hide() {
			this.containerclass = `hidden ${this.$store.state.bg_class}`;
		},
		resend() {
			if (this.resendLockoutTimer === 0) {
				this.$emit('resend');
				this.resendLockoutTimer = 30;
			}

			if (this.resendLockoutInterval === null) {
				this.resendLockoutInterval = setInterval(() => {
					if (this.resendLockoutTimer > 0) {
						this.resendLockoutTimer--;
					} else {
						this.clearTimer();
					}
				}, 1000);
			}
		},
		clearTimer() {
			this.resendLockoutTimer = 0;
			clearInterval(this.resendLockoutInterval);
			this.resendLockoutInterval = null;
		},
		setup() {
			this.$emit('setup');
		},
	},
};
</script>

<style lang="scss" scoped>
span.wait {
	cursor: disabled;
}
</style>
